/**
 * The catalogs of the tenant: the destination indices of its loaders, once each and sorted,
 * except the index of the loader being edited (it reads from another catalog).
 * @param {Map|Array|undefined} loaders - The loaders of the tenant.
 * @param {string} [ownIndex] - The destination index of the loader being edited.
 * @returns {string[]} The indices.
 */
export function catalogOptions(loaders, ownIndex) {
  const rows = loaders ? [...(loaders.values?.() ?? loaders)] : [];
  const indices = new Set();
  for (const loader of rows) {
    const index = typeof loader?.index === "string" ? loader.index.trim() : "";
    if (index && index !== ownIndex) indices.add(index);
  }
  return [...indices].sort();
}
